/**
 * @generated SignedSource<<cba42b72660dcb77143372eb263611f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RunnerStatus = "IDLE" | "PREPARING" | "RUNNING" | "SHARED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type Runner_runner$data = {
  readonly assignedGitHubJob: {
    readonly completedAt: any | null | undefined;
    readonly conclusion: string | null | undefined;
    readonly createdAt: any;
    readonly externalUrl: string;
    readonly jobId: string;
    readonly name: string;
    readonly owner: string;
    readonly repository: string;
    readonly startedAt: any | null | undefined;
    readonly status: string;
  } | null | undefined;
  readonly id: string;
  readonly organizationName: string;
  readonly slots: number;
  readonly status: RunnerStatus;
  readonly vmInfo: {
    readonly image: string;
  } | null | undefined;
  readonly " $fragmentType": "Runner_runner";
};
export type Runner_runner$key = {
  readonly " $data"?: Runner_runner$data;
  readonly " $fragmentSpreads": FragmentRefs<"Runner_runner">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Runner_runner",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slots",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VirtualMachineInfo",
      "kind": "LinkedField",
      "name": "vmInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "image",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GithubWorkflowJobInfo",
      "kind": "LinkedField",
      "name": "assignedGitHubJob",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "owner",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "repository",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "conclusion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "completedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Runner",
  "abstractKey": null
};
})();

(node as any).hash = "673d04d450ca5493171e2c97ac3d7197";

export default node;
